import NotificationBell from "@/components/layout/NotificationBell";
import GlobalSearch from "@/components/layout/GlobalSearch";
import UserMenu from "@/components/layout/UserMenu";
import FavoritosBar from "@/components/layout/FavoritosBar";
import { List, PushPin } from "@phosphor-icons/react";
import { useSidebar } from "@/context/SidebarContext";

/**
 * Barra superior persistente que vive sobre las solapas de módulos.
 * Contiene: toggle sidebar · label ERP · buscador global · notificaciones · menú de usuario.
 */
export default function GlobalTopBar() {
  const { pinned, pin, show } = useSidebar();
  return (
    <div
      className="h-10 bg-neutral-900 text-white border-b border-neutral-800 flex items-center pl-3 pr-0 gap-3 flex-shrink-0 no-print"
      data-testid="global-topbar"
    >
      {!pinned && (
        <button
          type="button"
          onMouseEnter={show}
          onClick={pin}
          title="Mostrar panel lateral (click para fijarlo)"
          data-testid="sidebar-expand-btn"
          className="flex items-center gap-1.5 h-7 px-2 rounded-md hover:bg-white/10 transition-colors text-white shrink-0"
        >
          <List size={14} weight="bold" />
          <PushPin size={10} weight="bold" className="opacity-70" />
        </button>
      )}
      <FavoritosBar />
      {/* Buscador global oculto temporalmente a pedido del usuario; se reactiva quitando el `false &&`. */}
      {false && (
        <>
          <div className="w-px h-5 bg-white/15 shrink-0" />
          <GlobalSearch />
        </>
      )}
      <div className="flex-1" />
      <div className="flex items-center gap-2 shrink-0">
        <NotificationBell />
        <UserMenu />
      </div>
    </div>
  );
}
